module.exports = __webpack_public_path__ + "static/img/canguanico.0a34413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/canguanico.png
// module id = eeUp
// module chunks = 1